/**
 * Members API
 * 
 * Handles club membership and member management.
 */

import { apiGet, apiPost, apiPut, apiDelete } from '../api';

export interface Member {
  id?: string; // Alias for user_id
  user_id: string;
  club_id: string;
  role: 'owner' | 'leader' | 'moderator' | 'member';
  first_name: string | null;
  last_name: string | null;
  public_display_name: string;
  email: string;
  profile_image_url: string | null;
  user_level: string;
  joined_at: string;
}

export interface AddMemberPayload {
  user_id: string;
  role?: 'leader' | 'member';
}

export interface UpdateMemberRolePayload {
  role: 'leader' | 'member';
}

export const membersApi = {
  /**
   * Get all members of a club
   * GET /clubs/:clubSlug/members
   */
  getClubMembers: (clubSlug: string) => 
    apiGet<Member[]>(`/clubs/${clubSlug}/members`),

  /**
   * Add member to club
   * POST /clubs/:clubSlug/members
   */
  addMember: (clubSlug: string, payload: AddMemberPayload) => 
    apiPost<void>(`/clubs/${clubSlug}/members`, payload),

  /**
   * Update member role
   * PUT /clubs/:clubSlug/members/:userId/role
   */
  updateMemberRole: (clubSlug: string, userId: string, payload: UpdateMemberRolePayload) => 
    apiPut<void>(`/clubs/${clubSlug}/members/${userId}/role`, payload),

  /**
   * Remove member from club
   * DELETE /clubs/:clubSlug/members/:userId
   */
  removeMember: (clubSlug: string, userId: string) => 
    apiDelete<void>(`/clubs/${clubSlug}/members/${userId}`),
};
